<template>
  <div class="chat">
    <div v-if="chat" class="test">
      <div class="chat-messages" id="chat-messages">
        <p
          class="chat-message"
          v-for="(message, idx) in chatMessages"
          :key="idx"
        >
          <span style="font-weight: bold;" v-if="typeof message != 'string'"
            >{{ message.sender }}:
          </span>
          <span
            class="has-text-weight-bold has-text-warning"
            v-if="typeof message == 'string'"
          >
            {{ message }}
          </span>
          <span v-else>
            {{ message.content }}
          </span>
        </p>
      </div>
      <b-field grouped>
        <b-input
          v-model="textInput"
          placeholder="send message..."
          @focus="show"
          @blur="hide"
          @hover="show"
          @keypress.native.enter="sendMessage"
          expanded
        ></b-input>
        <button class="button is-dark" @click="sendMessage" @focus="show">
          Send
        </button>
      </b-field>
    </div>
    <b-button
      id="chat-toogle"
      class="button is-dark"
      @click="toogleChat"
      rounded
      size="is-large"
      icon-left="message"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "chat",
  data: () => ({
    chat: false,
    textInput: "",
    showChat: true,
    plopSound: new Audio("/pop.mp3")
  }),
  methods: {
    toogleChat() {
      this.chat = !this.chat;
    },
    sendMessage() {
      if (this.textInput.length == 0) return;
      this.sendMessageToRoom("newMessage", this.textInput);
      this.textInput = "";
    },
    hide() {
      this.showChat = false;
    },
    show() {
      this.showChat = true;
    }
  },
  computed: {
    ...mapState(["chatMessages"])
  },
  mounted() {
    this.$colyseus.room.onMessage("receivedMessage", message => {
      this.$store.commit("addMessage", message);
    });
    this.$colyseus.room.onMessage("serverMessage", string => {
      this.$store.commit("addMessage", string);
    });
  },
  watch: {
    chatMessages() {
      let objDiv = document.getElementById("chat-messages");
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
      if (this.showChat == false) {
        this.plopSound.volume = 0.2;
        this.plopSound.play();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.test {
  display: flex;
  position: absolute;
  bottom: 55px;
  width: 400px;
  max-width: 100vw;
  max-height: calc(100vh - 55px);
  right: 0;
  flex-direction: column;
}
.chat {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100vw;
  bottom: 10px;
  right: 10px;
  border-radius: 5px;
  z-index: 3;
  @media only screen and (max-width: 800px) {
    left: 0;
    bottom: 0;
  }
}
.chat-messages {
  background-color: rgba(0, 0, 0, 0.9);
  height: calc(100% - 60px) !important;
  width: 100%;
  padding-left: 10px;
  padding-top: 10px;
  overflow-x: auto;
  overflow-y: wrap;
  overflow-wrap: anywhere;
}

.chat-message {
  text-overflow: wrap;
  text-align: left;
}

#chat-toogle {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
